import { defineNuxtPlugin, useRoute, useRouter } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute()
    const router = useRouter()
    const { scrollToElement } = useSmoothScroll()
    const { $bootstrap } = useNuxtApp()
    const { expandAccordionIfNeeded } = useExpandAccordion()
    
    const waitForElementAndScroll = (id: string, interval = 100, timeout = 5000) => {
        if (import.meta.client) {
            const start = Date.now()
            const timer = setInterval(() => {
                const el = document.getElementById(id)
                if (el || Date.now() - start > timeout) {
                    if (el) {
                        expandAccordionIfNeeded(id)
                        setTimeout(() => {
                            scrollToElement(id)
                        }, 300)
                    }
                    clearInterval(timer)
                }
            }, interval)
        }
    }

    const handleScroll = () => {
        const targetId = route.query.target as string | undefined
        const hashId = route.hash ? route.hash.substring(1) : undefined

        const idToScroll = targetId || hashId
        if (idToScroll) {
            waitForElementAndScroll(idToScroll)
        }
    }

    if (import.meta.client) {
        onMounted(() => handleScroll())
        router.afterEach(() => handleScroll())
    }
})
